// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2F_Ef","choiceBoxes":"toolbarselects_choiceBoxes__Ik-9W","simpleField":"toolbarselects_simpleField__3IMtP"};